/**
 * Fetch via Ajax (Enhanced)
 */
 class Fetch {

    constructor() {}

    put(url, data, callback, unauth, error) {

        this.call(url, data, "PUT", callback, unauth, error);

    }

    get(url, responseType, callback, unauth, error) {
        
        var fetchData = new Object();
        fetchData.method = "GET"
        fetchData.headers = { "X-Requested-With": "XMLHttpRequest", "Accept": responseType };
        
        this.execute(url, fetchData, responseType, callback, unauth, error);

    }

    post(url, data, callback, unauth, error) {

        this.call(url, data, "POST", callback, unauth, error);

    }

    delete(url, callback, unauth, error) {

        var fetchData = new Object();
        fetchData.method = "DELETE"
        fetchData.headers = { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" };
        
        this.execute(url, fetchData, "application/json", callback, unauth, error);
        
    }

    call(url, data, method, callback, unauth, error) {

        var fetchData = new Object();
        fetchData.method = method;
        fetchData.headers = { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json", "Accept": "application/json" };
        fetchData.body = JSON.stringify(data);

        this.execute(url, fetchData, "application/json", callback, unauth, error);

    }

    execute(url, fetchData, responseType, callback, unauth, error) {

        $(document).trigger(Fetch.AJAX_REQUEST);
        fetch(url, fetchData)
        .then(function(response) {
            $(document).trigger(Fetch.AJAX_RESPONSE);
            if (!response.ok) { throw response; }
            return response;
        })
        .then(function(response) {
            if (responseType == "application/json") {
                response.json().then(function(json) {
                    var result = new Object();
                    result.type = "OK";
                    result.status = response.status;
                    result.data = json;
                    callback(result);			
                });
            }
            else if (responseType == "text/html") {
                response.text().then(function(html) {
                    var result = new Object();
                    result.type = "OK";
                    result.status = response.status;
                    result.data = html;
                    callback(result);
                });
            }
            else {
                console.warn("Unknown response type: " + responseType);
                callback(null);
            }
        })
        .catch($.proxy(function(response) {
            var result = new Object();
            result.status = response.status;
			result.data = null;
			if (result.status == 401 && unauth != null) {
				result.type = "UNAUTH";
				unauth(result);
			}
			else {
	            result.type = "ERROR";
				error(result);
			}
        }, this));

    }

}

Fetch.AJAX_REQUEST = "AJAX_REQUEST";
Fetch.AJAX_RESPONSE = "AJAX_RESPONSE";


